import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { XdrSearchTabPanelComponent } from '../component/XdrSearchTabPanelComponent';
import { XdrSearchTabPanelView } from '../view/XdrSearchTabPanelView';
import { XdrSearchWebComponent } from '../../xdrSearch';
import { templateXdrSearchTab } from '../view/template';
import { XdrSearchResultsDetailsPanelEvents } from '../../xdrSearchResultsPanel/types';
import { Target } from '../../../../../../libs/shared/dtos/types/dashboards/src/lib/shared-dtos-dashboards-common';
import { GzTabChangeEvent } from '../../../ui/gzTabs/gzTabGroup/events/GzTabChangeEvent';
import { GzTabWebComponent } from '../../../ui/gzTabs/gzTab';
import { GzTabGroupEvents } from '../../../ui/gzTabs/gzTabGroup/types/types';

export class XdrSearchTabPanelController extends BaseWebComponentController {
  public component: XdrSearchTabPanelComponent;
  public view: XdrSearchTabPanelView;

  constructor(component: XdrSearchWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: XdrSearchTabPanelView,
      viewTemplate: templateXdrSearchTab,
    });
  }

  public selectActiveTabById(tabId: string, suppressEvent: boolean = false) {
    const tabGroup = this.view.dom.$tabGroup;
    const tabs = tabGroup.tabs;

    const currentlySelectedTab = this.getCurrentActiveTab();

    if (currentlySelectedTab.id === tabId) {
      // tab already selected -> do nothing
      return;
    }

    for (let tabIndex = 0; tabIndex < tabs.length; tabIndex++) {
      const tab = tabs[tabIndex];
      if (tab.id === tabId) {
        tabGroup.selectTab(tabIndex, suppressEvent)
        return;
      }
    }

    console.warn("Requested tab [" + tabId + "] was not found!");
  }

  private getCurrentActiveTab(): GzTabWebComponent {
    for (const tab of this.view.dom.$tabGroup.tabs) {
      if (tab.selected) {
        return tab;
      }
    }
    return this.view.dom.$tabGroup.tabs[0];
  }

  private async onTabChange(event: GzTabChangeEvent) {
    const activeCompany = this.dependencies.getActiveCompany();
    if (event.currentTab === 0) { //historical search
      await this.view.dom.$searchApp.setCompanyFilter(activeCompany);
    }
    if (event.currentTab === 1) { //live search
      await this.view.dom.$searchLive.controller.setSelectedFilterBasedOnChangedCompany(activeCompany);
    }
  }

  private resetPivotingValuesToDefault(): void {
    this.component.errorMessage = null;
    this.component.pivotingParams = null;
    this.component.pivotingToLoadedComponent = null;
  }

  public closeSideMenu(): void {
    this.view.dom.$searchApp.controller.closeSideMenu();
  }

  public async setCompanyFilter(company: Target) {
    await Promise.all([
      this.view.dom.$searchApp.setCompanyFilter(company),
      this.view.dom.$searchLive.controller.setSelectedFilterBasedOnChangedCompany(company),
    ]);
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$detailsPanel,
        event: XdrSearchResultsDetailsPanelEvents.REFINE_SEARCH_FROM_SIDE_PANEL,
        callback: (event) => this.view.dom.$searchApp.controller.onSidePanelFiltering(event),
      },
      {
        element: this.view.dom.$tabGroup,
        event: GzTabGroupEvents.TAB_CHANGE,
        callback: this.onTabChange.bind(this),
      }
    ];
  }

  async getDataForView(): Promise<any> {
    const dataForView = {
      activeTabId: this.component.getActiveTabId(),
      pivoting: {
        isPivoting: this.component.pivotingParams || this.component.errorMessage,
        pivotingToLoadedComponent: this.component.pivotingToLoadedComponent,
        params: this.component.pivotingParams,
        errorMessage: this.component.errorMessage,
      }
    };

    this.resetPivotingValuesToDefault();
    return dataForView;
  }
}
